import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { reject } from "lodash";
import { error } from "src/theme/palette";
import bearerToken from "../constant/token"
//Create permissions by createAsyncThunk
export const CreatePermission = createAsyncThunk("create/permissions", async (data, { rejectWithValue }) => {
  console.log("create/permissions", data)
  const FetchedDataWithApi = await fetch("http://localhost:4500/v1/permissions", {
    method: "POST",
    headers: {
      'Authorization': `Bearer ${bearerToken}`,
      'content-type': "application/json"
    },
    body: JSON.stringify(data)
  })
  try {
    const resultData = await FetchedDataWithApi.json()
    console.log("post ResultData", resultData)
    return resultData
  } catch (error) {
    return rejectWithValue("something wrong", error)
  }
});

//Read permissions by createAsyncThunk
export const ReadPermission = createAsyncThunk("read/permissions", async (data, { rejectWithValue }) => {
  //fetching data with api 1st we have to take console
  console.log("read/permissions", data)
  const FetchedDataWithApi = await fetch("http://localhost:4500/v1/list/permission", {
    method: "GET",
    headers: {
      'Authorization': `Bearer ${bearerToken}`
    }
  })
  try {
    const resultData = await FetchedDataWithApi.json()
    console.log("this will be the permission read data", resultData)
    return resultData;
  } catch (error) {
    return rejectWithValue("something wrong", error)
  }
})

//Update permissions by createAsyncThunk
export const UpdatePermission = createAsyncThunk("updates/permissions", async (data, { rejectWithValue }) => {
  //fetching data with api 1st we have to take it console
  console.log("updates/permissions", data)
  const FetchedDataWithApi = await fetch(`http://localhost:4500/v1/permissions/${data.id}`, {
    method: "PATCH",
    headers: {
      'Authorization': `Bearer ${bearerToken}`,
      'content-type': "application/json"
    },
    body: JSON.stringify(data)
  })
  try {
    const resultData = await FetchedDataWithApi.json()
    console.log("this will be the update data", resultData)
    return resultData
  } catch (error) {
    return rejectWithValue("something wrong", error)
  }
})

//delete permissions with createAsyncThunk
export const DeletePermission = createAsyncThunk("delete/permissions", async (id, { rejectWithValue }) => {
  //fetching data with api 1st we have to take it console
  console.log("delete/permissions", id)
  const FetchedDataWithApi = await fetch(`http://localhost:4500/v1/permissions/${id}`, {
    method: "DELETE",
    headers: {
      'Authorization': `Bearer ${bearerToken}`,
      "content-type": 'application/json'
    },
    body: JSON.stringify(id)
  })
  try {
    const resultData = await FetchedDataWithApi.json()
    console.log("this will be the Delete data", resultData)
    return resultData
  } catch (error) {
    return rejectWithValue("something wrong", error)
  }
});

//slices creation for permission Data
export const permissionDetail = createSlice({
  name: "permission",
  initialState: {
    permission: [],
    loading: false,
    error: null,
    searchData: [],
    deleteSuccess: false,
    registerSuccess: false
  },
  reducers: {
    searchPermission: (state, action) => {
      console.log(action.payload);
      state.searchData = action.payload;
    },
    resetRegisterSuccess: (state) => {
      state.registerSuccess = false;
    },
    resetDeleteSucess: (state) => {
      state.deleteSuccess = false;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(CreatePermission.pending, (state) => {
        state.loading = true;
        state.registerSuccess = false;
      })
      .addCase(CreatePermission.fulfilled, (state, action) => {
        state.loading = false;
        state.permission.push(action.payload);
        state.registerSuccess = true;
      })
      .addCase(CreatePermission.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.message;
        console.log("this will be the error massage", error)
        state.registerSuccess = false
      })
      .addCase(ReadPermission.pending, (state) => {
        state.loading = true;
      })
      .addCase(ReadPermission.fulfilled, (state, action) => {
        state.loading = false;
        state.permission = action.payload;
      })
      .addCase(ReadPermission.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(DeletePermission.pending, (state) => {
        state.loading = true;
        state.deleteSuccess = false;
      })
      .addCase(DeletePermission.fulfilled, (state, action) => {
        state.loading = false;
        const { id } = action.payload;
        if (id) {
          state.permission = state.permission.filter((ele) => ele.id !== id);
          state.deleteSuccess = true;
        }
      })
      .addCase(DeletePermission.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.deleteSuccess = false
      })
      .addCase(UpdatePermission.pending, (state) => {
        state.loading = true;
      })
      .addCase(UpdatePermission.fulfilled, (state, action) => {
        state.loading = false;
        state.permission = state.permission.map((ele) =>
          ele.id === action.payload.id ? action.payload : ele
        );
      })
      .addCase(UpdatePermission.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.message;
      });
  },
});

export default permissionDetail.reducer;
export const { searchPermission, resetRegisterSuccess, resetDeleteSucess } = permissionDetail.actions;